import React from 'react';
import { Link } from 'react-router-dom';
import { ListItem } from './ProfileContent';
import ProfileLeaveSettingsModal from '../../../components/modelpopup/ProfileLeaveSettingsModal';
import { useSelector } from "react-redux";
const ProfileLeaveSettings = () => {

    const employeeLeaves = useSelector((state) => state.employee.filteredLeaveData);

    const leaveData = [
        { id: 1, title: "Casual Leaves", text: employeeLeaves?.casualLeaves || 0 },
        { id: 2, title: "Carry Forward Leaves", text: employeeLeaves?.CarryforwardLeaves || 0 },
        { id: 3, title: "Medical Leave", text: employeeLeaves?.medicalLeave || 0 },
        { id: 4, title: "Carry Forward", text: employeeLeaves?.carryFlag ? "Yes" : "No" },
    ];
    return (
        <div className="tab-content">
            <div id="emp_profile" className="pro-overview tab-pane fade show active">
                <div className="row">
                    <div className="col-md-6 d-flex">
                        <div className="card profile-box flex-fill">
                            <div className="card-body">
                                <h3 className="card-title">
                                    Leave Information
                                    <Link
                                        to="#"
                                        className="edit-icon"
                                        data-bs-toggle="modal"
                                        data-bs-target="#leave_settings_modal"
                                    >
                                        <i className="fa fa-pencil" />
                                    </Link>
                                </h3>
                                <ul className="personal-info">
                                    {leaveData.map((item, index) => (
                                        <ListItem
                                            id={index}
                                            key={index}
                                            title={item.title}
                                            text={item.text}
                                        />
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ProfileLeaveSettingsModal />
        </div>
    );
};

export default ProfileLeaveSettings;
